import {useCallback, useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';

// GA Imports
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {DetailsGAClickEventActions} from '@stencil/hotels-config/src/config/ga-config';

// utils
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

//Omniture Imports
import {omnitureConfig} from '@stencil/omniture-analytics';
import {DetailsPageComponents} from '@stencil/omniture-analytics/src/constants/details';
import useOmnitureImpressions from '@stencil/omniture-analytics/src/hooks/useOmnitureImpressions';

// styles
import * as S from './WhyIndianBook.styles';
import {setLoadedComponents} from '@stencil/omniture-analytics/src/omniture-utils';

// define the default value
const numberOfLementsToShow = 3;

const WhyIndianBook = ({indianness}) => {
  const dispatch = useDispatch();
  const [showMoreClicked, setShowMoreClicked] = useState(false);

  const [omniWatcherRef] = useOmnitureImpressions(
    DetailsPageComponents.IndiannessSection,
    omnitureConfig.pages.DetailsUnif,
    {
      indianness: `${DetailsPageComponents.IndiannessSection}_shown`,
    },
  );

  useEffect(() => {
    dispatch(
      detailsPagePushGaThunk({
        eventAction: DetailsGAClickEventActions.indianness.action.sectionViewed,
      }),
    );
  }, []);

  useEffect(() => {
    if (indianness?.cardInfo?.iconURL || indianness?.cardInfo?.cardPayload) {
      setLoadedComponents(`${DetailsPageComponents.LBI}_shown`);
    }
  }, [indianness?.cardInfo?.iconURL]);

  const updatedData = useMemo(() => {
    const {genericCardData} = indianness?.cardInfo?.cardPayload || {};
    if (!isValidArray(genericCardData)) return [];
    return showMoreClicked ? genericCardData : genericCardData.slice(0, numberOfLementsToShow);
  }, [showMoreClicked, indianness?.cardInfo?.cardPayload]);

  const handleOnClickShowMore = useCallback(() => {
    setShowMoreClicked(true);
  }, [setShowMoreClicked]);

  return (
    <S.WhyIndianBookWrapper ref={omniWatcherRef}>
      {!!indianness?.cardInfo?.iconURL && (
        <span>
          <S.IndianFlagIconStyled src={indianness?.cardInfo?.iconURL} alt="indian flag" />
        </span>
      )}
      <S.WhyIndianBookHeading>
        <h3>{indianness?.cardInfo?.titleText}</h3>
      </S.WhyIndianBookHeading>
      <S.WhyIndianBookReasons>
        {updatedData.map((item, index) => (
          <li key={index}>
            {item.iconUrl && (
              <span className="reasonIcon">
                <S.ImageIconStyled src={item.iconUrl} alt={item.titleText} />
              </span>
            )}
            <div>
              <p>
                <span className="title">{item.titleText} - </span>
                <span dangerouslySetInnerHTML={{__html: item.subText}}></span>
              </p>
            </div>
          </li>
        ))}
      </S.WhyIndianBookReasons>
      {indianness?.cardInfo?.cardPayload?.genericCardData?.length > numberOfLementsToShow &&
        !showMoreClicked && <S.ViewAllBtn onClick={handleOnClickShowMore}>VIEW ALL</S.ViewAllBtn>}
    </S.WhyIndianBookWrapper>
  );
};

export default WhyIndianBook;
